import React, { Component } from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css';
import styled from 'styled-components';
import { Transition, config, animated } from 'react-spring';
import IntlMessageFormat from 'intl-messageformat';

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var data = { meta:{ forComponent:"MunicipalitySearch",
    language:"German" },
  label:"Suchen Sie nach einer Postleitzahl oder dem Gemeindenamen",
  placeholder:"3000 Bern",
  error:{ noResultsByZip:"Es wurde keine Gemeinde mit dieser Postleitzahl gefunden.",
    noResultsByName:"Es wurde keine Gemeinde mit diesem Namen gefunden.",
    municipalitiesNotDownloaded:"Die Gemeindeliste konnte nicht heruntergeladen werden. Die Suche steht zur Zeit nicht zur Verfügung." },
  list:{ municipalityPrefix:"Gemeinde",
    electoralDistrictPrefix:"Wahlkreis" },
  results:"{numResults, plural, =0 {Keine Resultate} one {Ein Resultat} other {# Resultate}}" };

var data$1 = { meta:{ forComponent:"MunicipalitySearch",
    language:"French" },
  label:"Cherchez par code postal ou par localité",
  placeholder:"1001 Lausanne",
  error:{ noResultsByZip:"Aucune commune n'a pu être trouvée avec ce numéro postal.",
    noResultsByName:"Aucune commune n'a pu être trouvée avec ce nom.",
    municipalitiesNotDownloaded:"La liste des communes n'a pas pu être téléchargée. La recherche est actuellement indisponible." },
  list:{ municipalityPrefix:"Commune:",
    electoralDistrictPrefix:"Wahlkreis" },
  results:"{numResults, plural, =0 {Aucun résultat} one {Un résultat} other {# résultats}}" };

var MESSAGES = { de: data, fr: data$1 };
var translationServiceFactory = function (messageList, locale) {
    return function (key) {
        if (key == null) {
            return '';
        }
        return (key
            .split('.')
            .reduce(function (messages, prop) { return messages[prop]; }, messageList[locale]) || 'TRANSLATED STRING NOT FOUND');
    };
};
var MunicipalityDownloadError = (function (_super) {
    __extends(MunicipalityDownloadError, _super);
    function MunicipalityDownloadError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MunicipalityDownloadError;
}(Error));
var startsWithNumber = /^\d/;
var containsOnlyLetters = /^\D+$/;
var containsFourDigits = /\d{4}/;
function showResults(results) {
    return results.length > 0 && results.length < 100;
}
var MunicipalitySearch = (function (_super) {
    __extends(MunicipalitySearch, _super);
    function MunicipalitySearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            results: [],
            value: '',
            error: null,
            municipalities: []
        };
        _this.resetComponent = function () {
            _this.setState({
                isLoading: false,
                results: [],
                value: ''
            });
        };
        _this.filterList = function (searchTerm) {
            var results = [];
            searchTerm = searchTerm.trim();
            if (searchTerm.length > 1 && _this.state.municipalities !== null) {
                var digitsResultsArray = containsFourDigits.exec(searchTerm);
                var municipalities = _this.state.municipalities;
                if (digitsResultsArray) {
                    var digits_1 = digitsResultsArray[0];
                    results = municipalities.filter(function (municipality) {
                        return municipality.PLZ4.toString() === digits_1;
                    });
                    if (results.length < 1) {
                        _this.setState({ error: 'error.noResultsByZip' });
                    }
                }
                else if (startsWithNumber.test(searchTerm)) {
                    results = municipalities.filter(function (municipality) {
                        return RegExp("^" + searchTerm).test(municipality.PLZ4.toString());
                    });
                    if (results.length < 1) {
                        _this.setState({ error: 'error.noResultsByZip' });
                    }
                }
                else if (containsOnlyLetters.test(searchTerm)) {
                    var sanitizedSearchTerm = searchTerm.replace('.', '\\.');
                    var r_1 = RegExp(sanitizedSearchTerm, 'i');
                    results = municipalities.filter(function (municipality) {
                        return r_1.test(municipality.ORTNAME) ||
                            r_1.test(municipality.GDENAMK) ||
                            r_1.test(municipality.NORMORTSNAME) ||
                            r_1.test(municipality.NORMGEMEINDE);
                    });
                    if (results.length < 1) {
                        _this.setState({ error: 'error.noResultsByName' });
                    }
                }
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'Interactions',
                    event_action: 'input',
                    event_label: "search:for_" + searchTerm + ":results_" + results.length
                });
            }
            return _this.removeDuplicates(results, searchTerm);
        };
        _this.handleSearchChange = function (e) {
            var value = e.currentTarget.value;
            _this.setState({ isLoading: true, value: value });
            if (value.length < 1) {
                return _this.resetComponent();
            }
            var results = _this.filterList(value);
            if (results.length > 0) {
                _this.setState({ error: null, isLoading: false, results: results });
            }
            _this.setState({ results: results, isLoading: false });
        };
        _this.sendToDataPipeline = function (plz4) {
            var BASE_URL = 'https://w.tda.io/b/votation';
            var ZIP = '?zip=' + plz4;
            var url = BASE_URL + ZIP;
            return window
                .fetch(url, {
                method: 'GET',
                mode: 'no-cors',
                credentials: 'include'
            })
                .then(function (response) {
                console.log(response);
            })
                .catch(function (error) {
                console.log(error);
            });
        };
        _this.pushToLocalStorageArray = function (newMuni) {
            var _a;
            var prevSelectedMunicipalities;
            var newArray = [];
            var localStorageItemName = 'selectedMunicipalities';
            try {
                prevSelectedMunicipalities = (_a = localStorage.getItem(localStorageItemName)) !== null && _a !== void 0 ? _a : JSON.stringify([]);
                newArray = JSON.parse(prevSelectedMunicipalities);
            }
            catch (_b) {
                console.warn('🗄 localStorage is not available');
            }
            var slicedArray = newArray.slice(0, 15);
            slicedArray.unshift(newMuni);
            try {
                localStorage.setItem(localStorageItemName, JSON.stringify(__spread(new Map(slicedArray.map(function (muni) { return [
                    muni.GDENR + muni.ORTNAME + muni.PLZ4,
                    muni
                ]; })).values())));
            }
            catch (_c) {
                console.warn('🗄 localStorage is not writeable');
            }
        };
        _this.getMunicipalitiesData = function () {
            _this.setState({
                isLoading: true
            });
            return fetch("https://interaktiv.tagesanzeiger.ch/static/gemeindesuche/" + _this.props.municipalityData + ".json")
                .then(function (res) {
                if (!res.ok) {
                    throw new MunicipalityDownloadError("Download error: " + res.status + ": " + res.statusText + ".");
                }
                return res.json();
            })
                .then(function (data) {
                _this.setState({
                    isLoading: false,
                    municipalities: data
                });
                return Promise.resolve(data);
            })
                .catch(function (error) {
                if (error instanceof MunicipalityDownloadError) {
                    console.log(error);
                    console.info('Make sure that you have the municipality and zip code data for the required year uploaded to the Interaktiv server.');
                    console.info('Read more about the data generation in the "data" directory in the project repository for the MunicipalitySearch React component.');
                    _this.setState({
                        isLoading: false,
                        error: 'error.municipalitiesNotDownloaded'
                    });
                }
                else {
                    throw error;
                }
            });
        };
        return _this;
    }
    MunicipalitySearch.prototype.removeDuplicates = function (arr, searchTerm) {
        var _this = this;
        var map = new Map();
        arr.forEach(function (v) {
            if (_this.props.dedupe) {
                map.set(v.ORTNAME + v.GDENR, v);
            }
            else {
                map.set(v.PLZ4 + v.ORTNAME + v.GDENR, v);
            }
        });
        var result = __spread(map.values()).reduce(function (acc, cur) {
            if (cur.GDENAMK.toLowerCase() === searchTerm.toLowerCase() ||
                cur.ORTNAME.toLowerCase() === searchTerm.toLowerCase()) {
                acc[0].push(cur);
            }
            else {
                acc[1].push(cur);
            }
            return acc;
        }, [[], []])
            .flat();
        return result;
    };
    MunicipalitySearch.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.municipalityData !== this.props.municipalityData) {
            this.resetComponent();
            this.getMunicipalitiesData();
        }
    };
    MunicipalitySearch.prototype.componentDidMount = function () {
        var _this = this;
        this.getMunicipalitiesData().then(function (data) {
            var locallyStoredMunicipalitiesArray;
            try {
                locallyStoredMunicipalitiesArray = localStorage.getItem('selectedMunicipalities');
            }
            catch (_a) {
                console.warn('🗄 localStorage is not available');
            }
            if (_this.props.showLastSelectedMunicipalities &&
                locallyStoredMunicipalitiesArray) {
                var parsed = JSON.parse(locallyStoredMunicipalitiesArray);
                var allBfsIdsAndNames_1 = parsed.map(function (muni) { return muni.GDENR + muni.ORTNAME + muni.PLZ4; });
                var filteredFromFetchedData = data.filter(function (muni) {
                    return allBfsIdsAndNames_1.includes(muni.GDENR + muni.ORTNAME + muni.PLZ4);
                });
                filteredFromFetchedData.sort(function (a, b) {
                    return allBfsIdsAndNames_1.indexOf((a.GDENR + a.ORTNAME + a.PLZ4)) - allBfsIdsAndNames_1.indexOf((b.GDENR + b.ORTNAME + b.PLZ4));
                });
                var dedupedData = __spread(new Map(filteredFromFetchedData.slice().reverse().map(function (muni) { return [
                    muni.GDENR + muni.ORTNAME + (_this.props.dedupe ? "" : muni.PLZ4),
                    muni,
                ]; })).values()).reverse();
                dedupedData.sort(function (a, b) {
                    return allBfsIdsAndNames_1.indexOf((a.GDENR + a.ORTNAME + a.PLZ4)) - allBfsIdsAndNames_1.indexOf((b.GDENR + b.ORTNAME + b.PLZ4));
                });
                var muniCount = _this.props.numberOfLastSelectedMunicipalities;
                _this.setState({
                    results: dedupedData.slice(0, muniCount)
                });
            }
        });
    };
    MunicipalitySearch.prototype.render = function () {
        var _this = this;
        var _a = this.state, isLoading = _a.isLoading, value = _a.value, results = _a.results;
        var t = translationServiceFactory(MESSAGES, this.props.locale);
        var resultString = new IntlMessageFormat(MESSAGES[this.props.locale].results, this.props.locale + '-CH');
        var labelContent = function () {
            if (_this.state.error) {
                return t(_this.state.error);
            }
            if (!!value && value.length >= 2) {
                return resultString.format({ numResults: results.length });
            }
            return t('label');
        };
        var labelDirection = window.matchMedia('screen and (max-width: 599px)')
            .matches
            ? 'top pointing'
            : 'left pointing';
        return (React.createElement(MunicipalitySearchContainer, { className: 'municipality-search' },
            React.createElement(InputRow, { className: 'inputRow' },
                React.createElement("div", { className: 'ui left icon input' },
                    React.createElement(FlexInput, { id: 'search', type: 'text', className: 'prompt flexInput', placeholder: this.props.placeholder || t('placeholder'), value: value, disabled: this.state.error === 'error.municipalitiesNotDownloaded', onChange: this.handleSearchChange }),
                    React.createElement(Icon, null,
                        React.createElement("svg", { width: '18', height: '18', viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', stroke: 'black', strokeWidth: '3' },
                            React.createElement("circle", { cx: '7.5', cy: '7.5', r: '6' }),
                            React.createElement("line", { x1: '11', y1: '11', x2: '17', y2: '17' })))),
                !this.props.hideTooltip && (React.createElement("div", null,
                    React.createElement("label", { htmlFor: 'search', className: "ui " + (this.state.error ? 'red' : 'basic grey') + " " + labelDirection + " label" }, labelContent())))),
            showResults(results) && (React.createElement(Results, { className: 'results' }, showResults(results) && (React.createElement(Transition, { native: true, items: results, keys: function (result) {
                    return result.PLZ4 + result.GDENR + result.ORTNAME;
                }, from: { transform: 'translate(0,-20px)', opacity: 0 }, enter: { transform: 'translate(0,0px)', opacity: 1 }, leave: { transform: 'translate(0, 60px)', opacity: 0 }, config: config.gentle }, function (values, result) { return (React.createElement(animated.div, { onClick: function () {
                    _this.props.onSelectionHandler(result);
                    if (_this.props.showLastSelectedMunicipalities) {
                        _this.pushToLocalStorageArray(result);
                    }
                    if (_this.props.resetOnSelect) {
                        _this.resetComponent();
                    }
                }, onKeyUp: function (e) {
                    if (e.key === 'Enter' || e.key === 'Space') {
                        _this.props.onSelectionHandler(result);
                        if (_this.props.resetOnSelect) {
                            _this.resetComponent();
                        }
                    }
                }, className: 'result', style: values, tabIndex: 0 },
                React.createElement(ResultHeader, { className: 'resultHeader' },
                    React.createElement(ResultPlz, { className: 'resultPlz' }, result.PLZ4),
                    ' ',
                    result.ORTNAME),
                React.createElement(ResultMeta, { className: 'resultMeta' },
                    t('list.municipalityPrefix'),
                    " ",
                    result.GDENAMK))); }))))));
    };
    MunicipalitySearch.defaultProps = {
        municipalityData: '2021v3',
        locale: 'de',
        numberOfLastSelectedMunicipalities: 1
    };
    return MunicipalitySearch;
}(Component));
var Icon = styled.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  padding-left: 0.8em;\n  opacity: 0.5;\n  transition: opacity 0.5s ease-in-out;\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  padding-left: 0.8em;\n  opacity: 0.5;\n  transition: opacity 0.5s ease-in-out;\n"])));
var MunicipalitySearchContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var InputRow = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  input:focus ~ i {\n    opacity: 1;\n  }\n  @media screen and (max-width: 599px) {\n    flex-direction: column;\n    .ui.input {\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  input:focus ~ i {\n    opacity: 1;\n  }\n  @media screen and (max-width: 599px) {\n    flex-direction: column;\n    .ui.input {\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n"])));
var FlexInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Results = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 1ex;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));\n  grid-gap: 0;\n  font-family: var(--ui-font-stack);\n  .result {\n    padding: calc(11 / 16 * 1em) calc(14 / 16 * 1em);\n    border-radius: 0.2ex;\n    box-shadow: 0 0 0 rgba(0, 0, 0, 0.3);\n    //border: 1px solid #007abf;\n    color: rgba(0, 0, 0, 0.9);\n    line-height: 1.1em;\n    cursor: pointer;\n    transition: box-shadow 200ms ease-in-out;\n    background-color: transparent;\n\n    &:hover,\n    &:focus {\n      box-shadow: 0 0 0.5ex rgba(0, 0, 0, 0.2), 0 0 0 1px #007abf inset;\n      background-color: $backgroundColor;\n    }\n  }\n"], ["\n  margin-top: 1ex;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));\n  grid-gap: 0;\n  font-family: var(--ui-font-stack);\n  .result {\n    padding: calc(11 / 16 * 1em) calc(14 / 16 * 1em);\n    border-radius: 0.2ex;\n    box-shadow: 0 0 0 rgba(0, 0, 0, 0.3);\n    //border: 1px solid #007abf;\n    color: rgba(0, 0, 0, 0.9);\n    line-height: 1.1em;\n    cursor: pointer;\n    transition: box-shadow 200ms ease-in-out;\n    background-color: transparent;\n\n    &:hover,\n    &:focus {\n      box-shadow: 0 0 0.5ex rgba(0, 0, 0, 0.2), 0 0 0 1px #007abf inset;\n      background-color: $backgroundColor;\n    }\n  }\n"])));
var ResultHeader = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-weight: 700;\n"], ["\n  font-weight: 700;\n"])));
var ResultPlz = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  opacity: 0.5;\n  font-weight: 400;\n"], ["\n  opacity: 0.5;\n  font-weight: 400;\n"])));
var ResultMeta = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  opacity: 0.66;\n  font-size: 0.9em;\n"], ["\n  opacity: 0.66;\n  font-size: 0.9em;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

export default MunicipalitySearch;
export { MunicipalitySearch };
//# sourceMappingURL=index.js.map
